module.exports = __webpack_public_path__ + "img/record.ee8e58c7.png";